module.exports = __webpack_public_path__ + "static/img/icon_01.a6bf7b30.png";